import { FC } from 'react';
import { Table } from '@dynamika-shared/ui/Table/Table';
import { NoContent } from '@dynamika-shared/ui/NoContent/NoContent';
import { makeTeamMemberColumns } from './ClinicalTrialsMembersTable.columns';
import { useTeamMembers } from '../../hooks/useTeamMembers';

export type MemberOptionType = 'edit' | 'suspend' | 'delete';

export const ClinicalTrialMembersPageView: FC = () => {
  const {
    teamMemberData,
    totalItems,
    loading,
    onSort,
    sortState,
    pagination,
    onClick,
    uiControlSchema,
    institutions,
  } = useTeamMembers();

  const teamMemberColumns = makeTeamMemberColumns(
    onClick,
    uiControlSchema,
    institutions
  );

  return (
    <div data-testid='ClinicalTrialMembersPageView'>
      <div className='relative mt-3 h-[calc(100%-120px)]'>
        <Table
          columns={teamMemberColumns}
          data={teamMemberData}
          totalItems={totalItems}
          loading={loading}
          onSort={onSort}
          sortState={sortState}
          pagination={pagination}
          pageSizeOptions={[20, 50, 100]}
          noContentMessage={
            <NoContent
              iconName={'team'}
              title={
                <span className='text-1424 text-spanishGray'>
                  No{' '}
                  <span className='font-semibold text-chineseBlack'>
                    Members
                  </span>{' '}
                  here yet! <br /> Click the button to add a member!
                </span>
              }
            />
          }
        />
      </div>
    </div>
  );
};
